import { useEffect, useRef, useState } from "react";
import { analyticsConfigured, setAnalyticsDisabled, trackPageView } from "../analytics";
import "./AnalyticsConsent.scss";

type Consent = "accepted" | "rejected" | null;
const storageKey = "aupps-analytics-consent";

function storedConsent(): Consent {
  try {
    const value = window.localStorage.getItem(storageKey);
    return value === "accepted" || value === "rejected" ? value : null;
  } catch {
    return null;
  }
}

export function AnalyticsConsent({ pageTitle, pageKey, showChoices, onCloseChoices }: {
  pageTitle: string;
  pageKey: string;
  showChoices: boolean;
  onCloseChoices: () => void;
}) {
  const [consent, setConsent] = useState<Consent>(storedConsent);
  const lastTrackedPage = useRef<string | null>(null);

  useEffect(() => {
    if (!analyticsConfigured) return;
    if (consent !== "accepted") {
      setAnalyticsDisabled(true);
      lastTrackedPage.current = null;
      return;
    }
    setAnalyticsDisabled(false);
    if (lastTrackedPage.current === pageKey) return;
    lastTrackedPage.current = pageKey;
    trackPageView(pageTitle);
  }, [consent, pageKey, pageTitle]);

  function choose(value: Exclude<Consent, null>) {
    try {
      window.localStorage.setItem(storageKey, value);
    } catch {
      // The choice still applies until the next page load when storage is unavailable.
    }
    setConsent(value);
    onCloseChoices();
  }

  if ((!analyticsConfigured || consent !== null) && !showChoices) return null;

  return (
    <aside className="analytics-consent" aria-label="Preferințe pentru analiză">
      <p>{analyticsConfigured
        ? "Folosim Google Analytics numai cu acordul tău pentru a înțelege cum este folosit site-ul. Poți schimba alegerea oricând."
        : "Google Analytics nu este activ în această versiune a site-ului. Poți salva preferința pentru versiunea în care va fi activ."}</p>
      <div className="analytics-consent__actions">
        <button type="button" onClick={() => choose("rejected")}>Refuză</button>
        <button type="button" onClick={() => choose("accepted")}>Acceptă</button>
      </div>
    </aside>
  );
}
